// Un pitido corto para confirmar —o negar— un escaneo.
//
// POR QUE HACE FALTA. Quien recibe mercancía mira la tarima y el lector,
// no la pantalla. Un escaneo que solo se confirma visualmente obliga a
// levantar la vista en cada pieza, y en cuanto alguien deja de hacerlo
// empieza a escanear sin saber si el sistema lo está contando. Dos tonos
// distintos —aceptado y rechazado— resuelven eso sin mirar.
//
// SIN DEPENDENCIAS ni archivos de sonido: un oscilador de WebAudio, que
// es lo mismo que hace cualquier lector de supermercado.
//
// El contexto se crea PEREZOSAMENTE, en el primer pitido, y no al cargar
// el módulo: los navegadores bloquean el audio hasta que hay un gesto del
// usuario, y crearlo antes deja un contexto suspendido que luego no suena.
let ctx = null;

function contexto() {
  if (ctx) return ctx;
  const Audio = window.AudioContext || window.webkitAudioContext;
  if (!Audio) return null;
  ctx = new Audio();
  return ctx;
}

function tono(hz, ms, volumen) {
  const c = contexto();
  if (!c) return;
  // Si el navegador lo suspendió (pestaña en segundo plano), se reanuda.
  if (c.state === 'suspended') c.resume().catch(() => {});

  const osc = c.createOscillator();
  const gan = c.createGain();
  osc.type = 'square';          // seco y penetrante, como el de un lector
  osc.frequency.value = hz;
  // Rampa de salida: un corte brusco produce un chasquido audible que
  // cansa mucho más que el propio pitido.
  gan.gain.setValueAtTime(volumen, c.currentTime);
  gan.gain.exponentialRampToValueAtTime(0.001, c.currentTime + ms / 1000);
  osc.connect(gan).connect(c.destination);
  osc.start();
  osc.stop(c.currentTime + ms / 1000);
}

// Agudo y muy corto: se oye y no molesta repetido doscientas veces.
export function pitidoOk() {
  try { tono(1760, 70, 0.05); } catch { /* el audio nunca corta el trabajo */ }
}

// Grave y más largo, y DOS veces: tiene que distinguirse de un acierto
// aunque haya ruido de carretilla alrededor.
export function pitidoError() {
  try {
    tono(220, 160, 0.09);
    setTimeout(() => tono(220, 160, 0.09), 190);
  } catch { /* el audio nunca corta el trabajo */ }
}
